import FieldError from "@/components/forms/FieldError";

type DomainHostnameFieldProps = {
  disabled?: boolean;
  error?: string;
  label: string;
  onChange: (value: string) => void;
  placeholder?: string;
  value: string;
};

export default function DomainHostnameField({
  disabled = false,
  error,
  label,
  onChange,
  placeholder = "example.com",
  value,
}: DomainHostnameFieldProps) {
  return (
    <label className="block">
      <span className="field-label">{label}</span>
      <div className="rounded-md focus-within:ring-2 focus-within:ring-primary/20">
        <div
          className={`flex overflow-hidden rounded-md border border-gray-300 shadow-xs focus-within:border-primary ${
            disabled ? "bg-gray-50" : "bg-white"
          }`}
        >
          <span className="flex items-center border-r border-gray-300 bg-gray-50 px-3 text-sm text-gray-500 select-none">
            https://
          </span>
          <input
            autoFocus
            className="block w-full border-0 bg-transparent px-3 py-2 text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:text-gray-500"
            disabled={disabled}
            onChange={(event) => onChange(sanitizeHostnameInput(event.target.value))}
            placeholder={placeholder}
            required
            type="text"
            value={value}
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
          />
        </div>
      </div>
      <FieldError error={error} />
    </label>
  );
}

export function sanitizeHostnameInput(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return "";

  try {
    const withScheme = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
    return new URL(withScheme).hostname;
  } catch {
    return trimmed
      .replace(/^https?:\/\//i, "")
      .split("/")[0]
      .split("?")[0]
      .split("#")[0];
  }
}
